import React from 'react';
import PropTypes from 'prop-types';
import ContentTitle from 'commons/ContentTitle';
import { I18N } from 'commons';
import SignUpProgressGraph from './SignUpProgressGraph';
import './SignUpHeader.scss';

const SignUpHeader = ({ currentSection }) => (
  <div className="SignUpHeader">
    <I18N
      tag={ContentTitle}
      i18n-title="new.registration.signup.create.account.label.completeProfile"
    />
    <div className="SignUpHeader__progress-graph">
      {
        !location.href.includes('edit-') &&
        <SignUpProgressGraph currentSection={currentSection} />
      }

    </div>
  </div>
);

SignUpHeader.propTypes = {
  currentSection: PropTypes.string,
};

SignUpHeader.defaultProps = {
  currentSection: '',
};

export default SignUpHeader;
